
// the script goes to the end of the body section
function onLoadChargeAfterSDKScript() {
    var config = {
        // Required: if not provided the SDK will not be initilized
        apiKey: window.chargeAfterKey,

        // Optional
        storeId: '',

        // Optional
        delegatedMerchantId: '',

        // Optional
        onLoaded: function() {
            // now we can work with chargeafter sdk
            // ChargeAfter.payments.present('apply')
            // ChargeAfter.payments.present('checkout',{...})

            // not required, automaticly handled by the SDK and widget
            // ChargeAfter.promotions.present('sku')
        },
        
        // Optional functionality that triggers when user flow finishes 
        // and modal closes
        onComplete: function(payload, context) {
            // payload includes same data as Apply/Checkout callbacks
            const {data, status, token} = payload;
            // 'APPLY' | 'CHECKOUT' 
            const source = context.source;
            
            /**
            only applicable for applications initiated from widget
            sku?: string;
            price?: string | number;
            category?: string;
            tag?: string;
            */
            const promotion = context.promotion;
        }
    };

    ChargeAfter.init(config);
}


var script = document.createElement('script');
script.src = window.chargeAfterSrc + '?t=' + Date.now();
script.type = 'text/javascript';
script.async = true;
script.onload = onLoadChargeAfterSDKScript;
document.body.appendChild(script);




window.addEventListener('DOMContentLoaded', () => {
    let apply = document.querySelectorAll('a[href="#apply"]');
    apply.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            // make sure ChargeAfter object is initialized prior to this line
            ChargeAfter.apply.present();
        })
    });
});



// Present the Apply UI modal box and pass it an options object
/*
ChargeAfter.apply.present(
  // This object is completely OPTIONAL, but recommended
  {
    // If you are in posession of the details, it will pre-fill the application and 		
    // provide a better customer experience
    consumerDetails: {
        firstName: "John",
        lastName: "Doe",
        email: "john.doe@gmail.com",      	
        merchantConsumerId: "merchant-internal-consumer-id",
        shippingAddress: {
            line1: "3 My Street",
            line2: "My Building, 4th floor",
            city: "New York",
            zipCode: "10019",
            state: "NY"
        },
        billingAddress: {
            line1: "3 My Street",
            line2: "My Building, 4th floor",
            city: "New York",
            zipCode: "10019",
            state: "NY"
        }
    },
    
    preferences: { 
      language: 'En' 
    },
  
    currency : 'USD',
    
    // This object is OPTIONAL
		filter: {
      creditTiers : ["SubPrime"], //possible value Prime, NearPrime, SubPrime
    }
    
    // optional string-string/number/Boolean/Date map
    // tags: {property: 'value'}
    
    // This callback allows you to process the result of the application process
    // see Callback completion pae for details
    callback: function(data, error) {    
    }
});
*/